module.exports = __webpack_public_path__ + "img/15.9d6c84e9.png";